// import file from "assets/images/file.png";
import Dropdown from "components/common/Dropdown";
import { t } from "i18next";
import { validateTextareaInput } from "utils/security";

const allowedFileTypes = ["pdf", "docx"];

export default function FourthStep({
  questions,
  formState,
  setFormState,
  // setLocalError,
}) {
  // Get selected questions from formState, fallback to questions with answers for backward compatibility
  const selectedQuestion = formState?.data?.selectedQuestions || 
    formState?.data?.questions
      ?.map((q, index) => q.answer && q.answer.length > 0 ? index : null)
      ?.filter(index => index !== null) || [];
  return (
    <div className="w-full">

      {/* Form Content */}
      <div className="space-y-4">
        
        {/* Questions Section */}
        <div className="space-y-3">
          <div className="flex items-center gap-2 mb-3">
            <div className="w-4 h-4 bg-purple-100 rounded-full flex items-center justify-center">
              <svg className="w-2 h-2 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h2 className="text-sm font-semibold text-gray-900">{t("signupAnswerQuestions")}</h2>
          </div>

          {/* Selected Questions Container */}
          {selectedQuestion.length > 0 && (
            <div className="space-y-3">
              {selectedQuestion.map((q, i) => (
                <div key={i} className="bg-gray-50 rounded-lg p-3">
                  <div className="flex justify-between items-start mb-2">
                    <label className="text-sm font-medium text-gray-700 flex-1 pr-2">
                      {questions[q]}
                    </label>
                    <div className="flex items-center gap-2 flex-shrink-0">
                      <span className="text-xs text-gray-500">
                        {formState?.data?.questions?.[q]?.answer?.length ?? 0}/1300
                      </span>
                      <button
                        onClick={() => {
                          setFormState((pre) => {
                            let ans = pre.data.questions;
                            ans[q].answer = "";
                            return {
                              ...pre,
                              data: {
                                ...pre.data,
                                questions: ans,
                                selectedQuestions: (pre.data.selectedQuestions || []).filter(index => index !== q),
                              },
                            };
                          });
                        }}
                        className="text-gray-400 hover:text-red-500 transition-colors duration-200"
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 18 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="w-3 h-3"
                        >
                          <path
                            d="M16 5L15.1327 17.1425C15.0579 18.1891 14.187 19 13.1378 19H4.86224C3.81296 19 2.94208 18.1891 2.86732 17.1425L2 5M7 9V15M11 9V15M12 5V2C12 1.44772 11.5523 1 11 1H7C6.44772 1 6 1.44772 6 2V5M1 5H17"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                  <div className="w-full">
                    <textarea
                      rows="3"
                      className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none text-sm"
                      placeholder={t("signupQuestionDescriptionPlaceholder")}
                      value={formState?.data?.questions[q]?.answer ?? ""}
                      onChange={(e) => {
                        const validation = validateTextareaInput(e.target.value, 1300);
                        if (validation.isValid) {
                          setFormState((pre) => {
                            let ans = pre.data.questions;
                            ans[q].answer = validation.sanitized;
                            return {
                              ...pre,
                              data: {
                                ...pre.data,
                                questions: ans,
                              },
                            };
                          });
                        }
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Question Selector */}
          {selectedQuestion.length < questions.length && (
            <div className="mt-3">
              <Dropdown
                label={t("signupQuestionnPickPlaceholder")}
                options={questions
                  .map((_, i) => ({
                    label: _,
                    value: i,
                  }))
                  .filter((q, i) => !selectedQuestion.includes(i))}
                onChange={(val) => {
                  setFormState((pre) => {
                    let ans = pre.data.questions;
                    if (!ans[val].answer) {
                      ans[val].answer = "";
                    }
                    return {
                      ...pre,
                      data: {
                        ...pre.data,
                        questions: ans,
                        selectedQuestions: [...(pre.data.selectedQuestions || []), val],
                      },
                    };
                  });
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
